export class BRCodePix {
    constructor() { }

    public id: number;
    public brCode: string;
    public imagemBRCode: string;
    public valor: number;
    
}